var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "#F1F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2939 15.2145C18.5586 15.2288 21.5383 12.8143 21.5383 9.87663C21.5383 6.66464 18.5586 4.44445 15.2939 4.44531H12.4842C9.18072 4.44445 6.46143 6.66508 6.46143 9.87663C6.46143 12.8149 9.18072 15.2288 12.4842 15.2145H15.2939Z",
    fill: "#0064A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7404 12.739V6.90624C15.0406 7.35586 15.9637 8.49105 15.9659 9.82254C15.9637 11.1539 15.0406 12.2884 13.7404 12.739ZM9.03582 9.82248C9.03862 8.49192 9.96037 7.35741 11.2598 6.9063V12.738C9.96044 12.2871 9.03862 11.1533 9.03582 9.82248ZM12.5004 4.89258C9.48165 4.89344 7.03521 7.0997 7.03467 9.82248C7.03528 12.5449 9.48165 14.7507 12.5004 14.7515C15.5201 14.7507 17.9668 12.5449 17.9672 9.82248C17.9668 7.0997 15.5201 4.89344 12.5004 4.89258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersCard);
export default __webpack_public_path__ + "static/media/diners-card.b11ed804c8b63217cb96f4480659801f.svg";
export { ForwardRef as ReactComponent };